// External libraries
import gql from 'graphql-tag';
import { CART_AMOUNTS_FRAGMENT } from '@/lib/graphql';

export const UPDATE_CALLBACK_OPTIONS_MUTATION = gql`
  mutation UpdateCallbackOptionsMutation(
    $callbackShippingMethods: [CallbackShippingMethodInput]
    $shippingOptionsSource: ShippingOptionsSource
    $token: String!
  ) {
    updateCallbackOptions(
      callbackShippingMethods: $callbackShippingMethods
      shippingOptionsSource: $shippingOptionsSource
      token: $token
    ) {
      cart {
        ...CartAmounts
      }
    }
  }

  ${CART_AMOUNTS_FRAGMENT}
`;
